import React from "react";
import { QuestionCard } from "../shared/QuestionCard";
import { QuizChoiceCard, ChoiceOption } from "../form/QuizChoiceCard";
import { ActivityLevel, ActivityLevelMeta } from "@/helpers/enums";
import { quizAsset } from "../shared/quizAssets";

type Props = {
  dogName: string;
  value?: ActivityLevel;
  onChange: (activity: ActivityLevel) => void;
};

const OPTIONS: ChoiceOption[] = [
  {
    value: ActivityLevel.LOW,
    label: "Couch potato",
    sublabel: ActivityLevelMeta[ActivityLevel.LOW].label,
    icon: quizAsset("icon-coach-potato"),
  },
  {
    value: ActivityLevel.MEDIUM,
    label: "Active",
    sublabel: ActivityLevelMeta[ActivityLevel.MEDIUM].label,
    icon: quizAsset("icon-active-dog"),
  },
  {
    value: ActivityLevel.HIGH,
    label: "Athlete",
    sublabel: ActivityLevelMeta[ActivityLevel.HIGH].label,
    icon: quizAsset("icon-athlete"),
  },
];

export function ActivityQuestion({ dogName, value, onChange }: Props) {
  return (
    <QuestionCard
      title={`How active is ${dogName || "your dog"}?`}
      field="activityLevel"
    >
      <QuizChoiceCard
        options={OPTIONS}
        selected={value ?? ""}
        onSelect={(v) => onChange(v as ActivityLevel)}
        size="sm"
      />
    </QuestionCard>
  );
}
